/**
 * FontAwesomeCustom, FAC, será el prefijo genérico para los iconos personalizado.
 */
 const prefix = "fac";

 /**
  * Se van creando los iconos pertinentes siguiendo esta estructura:
  *   1. Se crea un objeto fa<<Icono>> con los parámetros que aparecen abajo.
  *   2. Para sacar la información del svg la página https://vecta.io/nano simplifica el SVG.
  *   3. Se añade dentro de _iconsCache y se hace un export por cada icono.
  */
 const faJdA = {
   prefix: 'fac',
   iconName: 'jda',
   icon: [
     62,    // width     [Parámetro de svg]
     57,    // height    [Parámetro de svg]
     [],    // ligatures [Opcional]
     "",    // unicode   [Opcional]
     // svg path data    [Parámetro 'd' del path]
     "M12.4730476,60.000381 L0.499714286,60.000381 L28.6768571,0.0737142857 L40.6492381,0.0737142857 L64.4637143,59.8484762 L64.4357143,59.8477143 L64.5388571,60.0000952 L52.4912381,60.0000952 C47.7121905,55.6677143 41.3702857,53.0267619 34.4112381,53.0267619 C32.4426667,53.0267619 30.5255238,53.2439048 28.6769524,53.6448571 L28.6769524,53.6448571 L28.6769524,44.2772381 C30.5312381,43.9839048 32.4321905,43.8305714 34.368381,43.8305714 C38.7798054,43.8305714 43.0069381,44.6191906 46.9166101,46.0630963 L34.1551429,13.8865714 L12.4730476,60.000381 Z"
   ]
 };
 
 const _iconsCache = {
     faJdA,
 };
 
 export {_iconsCache as fac, prefix, faJdA};